// project-imports
import Navigation from './Navigation';
import SimpleBar from 'components/third-party/SimpleBar';
import SIDEBAR from '../sidebarStyles';
import { HEADER_HEIGHT } from 'config';

// ==============================|| DRAWER CONTENT ||============================== //

const DrawerContent = () => {
  return (
    <SimpleBar
      sx={{
        // was a hard-coded 64px, which did not match the 75px HEADER_HEIGHT and left the
        // scroll region 11px taller than the space available below the drawer header
        height: `calc(100vh - ${HEADER_HEIGHT}px)`,
        backgroundColor: SIDEBAR.bg,
        '& .simplebar-content': {
          display: 'flex',
          flexDirection: 'column',
          minHeight: '100%'
        },
        '& .simplebar-scrollbar::before': {
          backgroundColor: SIDEBAR.scrollThumb
        }
      }}
    >
      <Navigation />
    </SimpleBar>
  );
};

export default DrawerContent;
